import { render } from "./PlayedGamesView.vue?vue&type=template&id=2f595f5a&scoped=true"
import script from "./PlayedGamesView.vue?vue&type=script&lang=js"
export * from "./PlayedGamesView.vue?vue&type=script&lang=js"

import "./PlayedGamesView.vue?vue&type=style&index=0&id=2f595f5a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f595f5a"]])

export default __exports__